import { Component, OnInit, ViewChild,AfterViewChecked,AfterViewInit, Input, SimpleChanges, ElementRef } from '@angular/core';
import * as emiGlobals from 'app/globals';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { ICompanySpecificInfo } from "app/company-offers/services/icompany-specific-info";
import { LoanOfferGenService, BankCompanyResult } from "app/loan/services/loan-offer-gen.service";
import { NgbCarouselConfig, NgbCarousel, NgbTabChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from "rxjs/Subject";
import {NgbTabset} from "@ng-bootstrap/ng-bootstrap";
import { Observable } from "rxjs/Observable";
import { NgSelectorComponent } from "ng-selector";
import {URLSearchParams} from "@angular/http";
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {Router, ActivatedRoute, Params,NavigationExtras,NavigationCancel } from '@angular/router';
import 'rxjs/add/operator/map';

declare var $: any;

@Component({
  selector: 'pl-form',
  templateUrl: './pl-form.component.html',
  styleUrls: ['./pl-form.component.css'],
  providers: [NgbCarouselConfig] 
})


export class PlFormComponent implements OnInit,AfterViewInit {
  ActualPlCompany: any;
  company_id;
  extra;
  selectedTab:string; 
  @ViewChild('mobtab') private tabs:NgbTabset;
  @ViewChild('webtab') private tabsWeb:NgbTabset;
  
  @Input() maxeligibile;
  @Input() type;

  @ViewChild('plMobileCarouselForm') public mobilecarouselform :NgbCarousel;
  @ViewChild('carousel-indicators') public carouselindicators :NgbCarousel;
  @ViewChild('companySelect') public companySelect :ElementRef;
  @ViewChild('companySelectMobile') public companySelectMobile :ElementRef;

  x=true;
  url_comapnylist=[];
  set_data;
  sessionId: Observable<string>;
  userId;
  company_selected=false;
  loanApplyForm : FormGroup;
  mobileLoanForm: FormGroup;
  hide_personalize=true;
  defaultQuoteLoanAmount = "3,00,000";
  show;
  dataToApi;
  show_alert_message:boolean=true;
  show_Loan_TextExit=false;
  more_personalize:boolean=false;
  more_personalize_mobile:boolean=false;
  title="Personalise my offers";
  hide_on_mobile:boolean=true;
  hide_on_desktop:boolean=true;
  loan_amount_generated=false;
  loan_amount_label ="Loan Amount";

  PLNew = emiGlobals.PersonalLoan_New;
  PLBt  = emiGlobals.PersonalLoan_Transfer;
  activePanel = emiGlobals.PersonalLoan_New;
  active;
  gifActive=true;
  gifDeactive=false;

  options_locations=this.loanOfferService.getCityList();
  options_bank=this.loanOfferService.getBankList();
  // options_bank = emiGlobals.SalaryBankEnum;
  options_gender = emiGlobals.GenderEnum;
  option_loan_tenure = emiGlobals.PLLoanTenureEnum;
  option_workexp = emiGlobals.WorkExperienceEnum;
  option_emp_type =  emiGlobals.PersonalEmployementList;
  data=[];
  showCompany=true;
  showDepreciation=false;
  showNatureOfProfession=false;  

  q_type   = "enquiry";
  q_amount   = false;
  q_l_type   = this.type;
  mobileCarouselRowHeight;
  comapny_selector;
  comapny_selectorMobile;

  // PlCompanyListFiltered=new Array();

  companyIdInUrl; // If company id available in url

  private bankCompanySearchTerms = new Subject<string>();
  
  PLForm = { 
    bank_title:"Salary Account Bank",
    income_title:"Net Monthly Salary",
    income_amount:35000,
    work_exp_title:"Work Experience"
  };

	onValueChange($event:any) {
    	console.log('value change: ', $event);
	}
  
  constructor(
    private fb: FormBuilder,
    private loanOfferService:LoanOfferGenService,
    private route: ActivatedRoute,
    public router:Router,

    //private config: NgbCarouselConfig
  ) { 
    
  }
   

  ngOnInit() {
  console.log(this.maxeligibile);
  

    this.extra = this.route
    .queryParams
    .subscribe(params => {
      // Defaults to 0 if no query param provided.
      // this.page = +params['page'] || 0;
    
    
      if(Object.keys(params).length>0){
      
        this.setUrlParametersToLocal(params);
        this.loanOfferService.checkHasLocalData();
        this.buildForm();
        if(params.generate_quote=="true"){
        
          this.generateOffer(params);
        }
      } else {
        this.loanOfferService.checkHasLocalData();
        this.buildForm();
      }

    });

    this.activePanel=this.type;
    this.active=this.type;
    
  }


  ngOnChange(changes: SimpleChanges){
    if(changes['dataToApi']){
    }
  }

  ngAfterViewInit(){
    
    let token=localStorage.getItem('id_token');
    jQuery('body').on('focus', '#token-input-employername', function(event){
        
    });
    jQuery('#comp-multi-choose').hide();
    $('.gifImage').hide();

    // this.comapny_selector =  $(this.companySelect.nativeElement).tokenInput(emiGlobals.persoanlCompaniesList, {
    this.comapny_selector =  $(this.companySelect.nativeElement).tokenInput(emiGlobals.persoanlCompaniesList +'?token='+token, {
        theme: "facebook",
        minChars: 3,
        preventDuplicates: true,
        hintText: "Search your company name",
        crossDomain: false,
        onResult: function (item:any) {
         var PlCompanyListFiltered=[];
          if(this.PlCompanyListFiltered){
            PlCompanyListFiltered.length=0;
         }
          let filter_bank_id=JSON.parse(localStorage.getItem('PortalBank_Filter'));
        if(filter_bank_id.length==0){
          PlCompanyListFiltered=item;
          // return this.PlCompanyListFiltered;
          item=PlCompanyListFiltered;
        }else{
        
          if(item){
            for(let j=0;j<item.length;j++){
                for(let i=0;i<filter_bank_id.length;i++){
                   if(item[i]){
                     let bank=filter_bank_id[i];
                       if(bank){
                         if(bank==item[j].bankid){
                           this.ActualPlCompany=item[j];
                           PlCompanyListFiltered.push(this.ActualPlCompany);
                         }
                       }
                   }else{
                    console.log("no data");
                   }
               }
            }
          console.log(PlCompanyListFiltered);
          item=PlCompanyListFiltered;
        
          }
        
        }
          
            if ($.isEmptyObject(item)) {
               
                var text = $("tester").text();
                return [{ id: '0', name: text.replace("Company Name", "") }]
        
            } else {
              $('.gifImage').hide();
                return item;
            }
        },

        get: function () {
            return this.data("tokenInputObject").getTokens();
        },
    });

    // $('#gif').hover(
    //    function(){
    //       $('.gifImage').show();
    //    },
    //    function(){
          
    //       $('.gifImage').hide();
    //       $('#gif').unbind()
    //    }
    //  );
    //  $('.fa-question').hover(
    //    function(){
    //     $('.gifImage').show();
    //    },
    //    function(){
    //     $('.gifImage').hide(); 
    //    }
    //  );

   

    // this.comapny_selector =  $(this.companySelect.nativeElement).tokenInput("add",   {id:"856",name:"House"});
    
   
    this.comapny_selectorMobile =  $(this.companySelectMobile.nativeElement).tokenInput(emiGlobals.persoanlCompaniesList+'?token='+token, {
        theme: "facebook",
        minChars: 3,
        preventDuplicates: true,
        hintText: "Search your company name",
        crossDomain: false,
        onResult: function (item:any) {
          var PlCompanyListFiltered=[];
          if(this.PlCompanyListFiltered){
            PlCompanyListFiltered.length=0;
         }
          let filter_bank_id=JSON.parse(localStorage.getItem('PortalBank_Filter'));
        if(filter_bank_id.length==0){
          PlCompanyListFiltered=item;
          // return this.PlCompanyListFiltered;
          item=PlCompanyListFiltered;
        }else{
        
          if(item){
            for(let j=0;j<item.length;j++){
                for(let i=0;i<filter_bank_id.length;i++){
                   if(item[i]){
                     let bank=filter_bank_id[i];
                       if(bank){
                         if(bank==item[j].bankid){
                           this.ActualPlCompany=item[j];
                           PlCompanyListFiltered.push(this.ActualPlCompany);
                         }
                       }
                   }else{
                    console.log("no data");
                   }
               }
            }
          console.log(PlCompanyListFiltered);
          item=PlCompanyListFiltered;
        
          }
        
        }

            if ($.isEmptyObject(item)) {

                var text = $("tester").text();

                return [{ id: '0', name: text.replace("Company Name", "") }]

            } else {
                return item;
               
            }
        },

        get: function () {
            return this.data("tokenInputObject").getTokens();
        },
    });

    $('#carouselExampleIndicators').bind('slid.bs.carousel', function (e) {
        var active = $(e.target).find('.carousel-inner > .carousel-item.active');
        var active_id = active[0].id;
        console.log(active_id,active);
        if(active_id=='mob-company'){
          $('#comp-multi-choose').show();
        }else{
          $('#comp-multi-choose').hide();
        }
    });

    this.setUrlPassedCompaniesToSelectorWeb();
    this.setUrlPassedCompaniesToSelectorMob()
    this.onEmploymentChange(this.getFielsDefaultValue('emp_type_id',0));
    
  if(this.tabs) {
      this.tabs.select(this.active);
  }
  if(this.tabsWeb){
    this.tabsWeb.select(this.active);
  }
    
  }

  setUrlParametersToLocal(params) {
    this.loanOfferService.updateCustomerInfoData(
      {
        "loan_type":this.type,
        "loan_amount":params.loanamount?params.loanamount:300000,
        "loan_tenure_id":params.loan_tenure?params.loan_tenure:this.getFielsDefaultValue('loan_tenure_id',4),
        "loan_tenure":4,
        "netsalary":params.netsalary?params.netsalary:this.getFielsDefaultValue('netsalary',this.PLForm.income_amount),
        "existing_emi":params.emi?params.emi:this.getFielsDefaultValue('existing_emi','5000'),
        "salary_bank_account_id":params.bank_id?params.bank_id: this.getFielsDefaultValue('salary_bank_account_id',0),
        "salary_bank_account":this.options_bank[params.bank_id?params.bank_id: this.getFielsDefaultValue('salary_bank_account_id',0)].name,
        "work_exp_id":params.workexp_id,
        "work_exp":this.option_workexp[params.workexp_id?params.workexp_id: this.getFielsDefaultValue('work_exp_id',3)].name,
        "location_id":params.location_id,
        "location":this.options_locations[params.location_id?params.location_id:this.getFielsDefaultValue('location_id',0)].name,
        "gender_id":params.gender_id,
        "gender":this.options_gender[params.gender_id?params.gender_id:this.getFielsDefaultValue('gender_id',1)].name,
        "age":params.age?params.age:this.getFielsDefaultValue('age',28),
        "emp_type_id":params.emp_type_id?params.emp_type_id:this.getFielsDefaultValue('emp_type_id',0),
        "emp_type":this.option_emp_type[params.emp_type_id?params.emp_type_id:this.getFielsDefaultValue('emp_type_id',0)].name,
        "depre"   :params.depreciation?params.depreciation:this.getFielsDefaultValue('depre',0),
        "nature"  :params.nature?params.nature:this.getFielsDefaultValue('nature')
      }
    );

    this.companyIdInUrl = params.company_id;
    // this.buildForm();
  }

  setUrlPassedCompaniesToSelectorWeb(){
    if(this.companyIdInUrl){
      this.companyIdInUrl = this.companyIdInUrl.replace(/,\s*$/, "");
      this.loanOfferService.getCompanyNameByUrl(this.companyIdInUrl)
        .subscribe((response) => {
          this.data= response;
          if(this.data!=null){
            this.data.forEach(preselectedCompaines => {
              console.log(preselectedCompaines);
              this.comapny_selector =  $(this.companySelect.nativeElement).tokenInput("add",
                {
                  id: preselectedCompaines.id,
                  name: preselectedCompaines.name
                });
            })
          }
        });
    }    
  }
  setUrlPassedCompaniesToSelectorMob(){
    if(this.companyIdInUrl){
      this.companyIdInUrl = this.companyIdInUrl.replace(/,\s*$/, "");
      this.loanOfferService.getCompanyNameByUrl(this.companyIdInUrl)
        .subscribe((response) => {
          this.data= response;
          if(this.data!=null){
            this.data.forEach(preselectedCompaines => {
              console.log(preselectedCompaines);
              this.comapny_selectorMobile =  $(this.companySelectMobile.nativeElement).tokenInput("add",
                {
                  id: preselectedCompaines.id,
                  name: preselectedCompaines.name
                });
            })
          }
        });
    }   
  }

  

  

  buildForm(){
    this.loanApplyForm = this.fb.group({
  
      'netsalary': [this.getFielsDefaultValue('netsalary',this.PLForm.income_amount), Validators.compose([Validators.required, Validators.minLength(3)])],
      'existingemi':[this.getFielsDefaultValue('existing_emi','5000'), Validators.compose([Validators.required])],
      'salarybankaccount':[this.getFielsDefaultValue('salary_bank_account_id',0), Validators.compose([Validators.required])],
      'work_exp':[this.getFielsDefaultValue('work_exp_id',3), Validators.compose([Validators.required])],
      'age':[this.getFielsDefaultValue('age',28), Validators.compose([Validators.required])],
      'location':[this.getFielsDefaultValue('location_id',0), Validators.compose([Validators.required])],
      'gender':[this.getFielsDefaultValue('gender_id',0), Validators.compose([Validators.required])],

      'emp_type':[this.getFielsDefaultValue('emp_type_id',0), Validators.compose([Validators.required])],
      'employername':[null],
      'nature':[this.getFielsDefaultValue('nature')],
      'depre':[this.getFielsDefaultValue('depre',0)],
      'loanamount':[300000, Validators.compose([Validators.required])],
      'loantenure':[4, Validators.compose([Validators.required])],
    });
    this.mobileLoanForm =this.loanApplyForm;
 
  }
  ngAfterViewChecked(): void {
 
}

  
beforeLoanTypeChange($event: NgbTabChangeEvent){
  this.activePanel=$event.nextId;
  // this.selectedTab=this.activePanel;
  if ($event.nextId === emiGlobals.PersonalLoan_New) {
    this.type = emiGlobals.PersonalLoan_New;
    this.loan_amount_label = "Loan Amount";
  }else{
    this.type= emiGlobals.PersonalLoan_Transfer;
    this.loan_amount_label = "Loan Outstanding";
  }
}
beforeLoanTypeChangeMob($event: NgbTabChangeEvent){
  this.active=$event.nextId;
  this.selectedTab=this.active;
  if ($event.nextId === emiGlobals.PersonalLoan_New) {
    this.type = emiGlobals.PersonalLoan_New;
    this.loan_amount_label = "Loan Amount";
  }else{
    this.type= emiGlobals.PersonalLoan_Transfer;
    this.loan_amount_label = "Loan Outstanding";
  }
}


  getTitle(){
    return "Personalise my offers.";
    // if(this.type == emiGlobals.PersonalLoan_Transfer){
    //   return "Personalize my offers.";
    // }else if(this.type == emiGlobals.PersonalLoan_New){
    //   return "Personalize my offers";
    // }
  }

  showForm(){
    this.hide_on_mobile=false;
  }

  // Show Age, Gender and Work exp form : Show / Hide
  updatePersonalize(value){
    this.more_personalize = value;
  }
  updatePersonalizeMobile(value){
    this.x=false;
    this.hide_personalize=false;
    this.more_personalize_mobile=true;
    this.show=true;
    // this.carouselindicators.next();
  }

  submitForm(values,viewtype='web'){
     this.loanOfferService.checkHasLocalData();
    
      
    console.log(this.userId);
    console.log(values);
   
  
    this.q_type   = "enquiry";
    this.q_amount   = values.loanamount;
    this.q_l_type   = (this.type==emiGlobals.PersonalLoan_New?"New Loan" : "Balance Transfer");
    let tokenInput;
    if(viewtype=="mobile"){
      tokenInput = this.comapny_selectorMobile.tokenInput("get");
    }else{
      tokenInput = this.comapny_selector.tokenInput("get");
    }
    
    values.employername = tokenInput;
     if(values.emp_type==4||values.emp_type==3||values.emp_type==5){
         this.show_alert_message=true;
          console.log("values",values.employername);
          if(this.type=='Personal Loan'){
            this.router.navigate(['/loan/personal'], { 
              queryParams: {
                loanamount    : values.loanamount, 
                loan_tenure   : values.loantenure,
                netsalary     : values.netsalary,
                emi           : values.existingemi,
                bank_id       : values.salarybankaccount,
                work_exp_id   : values.work_exp,
                location_id   : values.location,
                gender_id     : values.gender,
                age           : values.age,
                emp_type_id   : values.emp_type,
                company_id    : this.getEmployerId(values.employername),
                generate_quote:true,
                depreciation  :values.depre,
                nature        :values.nature
                }
            });
          }
          if(this.type=='Personal Loan Transfer'){
            this.router.navigate(['/loan/personal/transfer'], { 
              queryParams: {
                loanamount    : values.loanamount, 
                loan_tenure   : values.loantenure,
                netsalary     : values.netsalary,
                emi           : values.existingemi,
                bank_id       : values.salarybankaccount,
                work_exp_id   : values.work_exp,
                location_id   : values.location,
                gender_id     : values.gender,
                age           : values.age,
                emp_type_id   : values.emp_type,
                company_id    : this.getEmployerId(values.employername),
                generate_quote:true,
                depreciation  :values.depre,
                nature        :values.nature
                }
            });
          }
         
     }else if(values.emp_type==0||values.emp_type==1||values.emp_type==2){
          if(values.employername==''){
              this.show_alert_message=false; //validation
              this.company_selected=true;
               if(viewtype=="mobile"){
                $('.carousel').carousel(3)
                
               }
      } else {
            this.show_alert_message=true;
            console.log("values",values.employername);
            this.company_selected=false;
            if(this.type=='Personal Loan'){
              this.router.navigate(['/loan/personal'], { 
                queryParams: {
                    loanamount    : values.loanamount, 
                    loan_tenure   : values.loantenure,
                    netsalary     : values.netsalary,
                    emi           : values.existingemi,
                    bank_id       : values.salarybankaccount,
                    work_exp_id   : values.work_exp,
                    location_id   : values.location,
                    gender_id     : values.gender,
                    age           : values.age,
                    emp_type_id   : values.emp_type,
                    company_id    : this.getEmployerId(values.employername),
                  generate_quote  :"true",
                  }
              });
            }
            if(this.type=='Personal Loan Transfer'){
              this.router.navigate(['/loan/personal/transfer'], { 
                queryParams: {
                    loanamount    : values.loanamount, 
                    loan_tenure   : values.loantenure,
                    netsalary     : values.netsalary,
                    emi           : values.existingemi,
                    bank_id       : values.salarybankaccount,
                    work_exp_id   : values.work_exp,
                    location_id   : values.location,
                    gender_id     : values.gender,
                    age           : values.age,
                    emp_type_id   : values.emp_type,
                    company_id    : this.getEmployerId(values.employername),
                  generate_quote  :"true",
                  }
              });
            }
          
       }
     }
    
   
  }

  generateOffer(params){
  
        try {
      let dataToApi           = Object.assign({}, params);
      dataToApi.emp_type          = this.option_emp_type[params.emp_type_id].value;
      dataToApi.salarybankaccount = this.options_bank[params.bank_id].value;
      dataToApi.loantenure        = this.option_loan_tenure[params.loan_tenure].value;
      dataToApi.workexp           = this.option_workexp[params.work_exp_id].value;
      dataToApi.location          = this.options_locations[params.location_id].value;
      dataToApi.gender            = this.options_gender[params.gender_id].value;
      dataToApi.loan_type         = this.type;
      dataToApi.employername      = params.company_id;
      dataToApi.loanamount        = params.loanamount;

       delete dataToApi.loan_tenure;
       delete dataToApi.bank_id;
       delete dataToApi.work_exp_id;
       delete dataToApi.location_id;
       delete dataToApi.gender_id;
       delete dataToApi.emp_type_id;
       delete dataToApi.generate_quote;
       delete dataToApi.company_id;
      // if(values.employername && values.employername instanceof Array){
      //   dataToApi.employername      = values.employername.join(",");
      // }
      
      this.dataToApi = dataToApi;
      this.loan_amount_generated=true;

      dataToApi.purp              = this.getTypeSpecificValue('purp');
      dataToApi.pid               = this.getPid('newloan');
      this.loanOfferService.generatePLCommonOffer(dataToApi);
      this.more_personalize =true;
      
    } catch (error) {
      console.log(error);
    }
  }
  

  getEmployerId(employernames){
    let id= "";
    let ename="";
    if(employernames){
      employernames.forEach(element => {
        console.log(element);
        id = id+element.id+',';
        ename = ename+ element.name+', ';
      });
    }
     this.loanOfferService.updateCustomerInfoData({
        "company_name":ename
       });
    return id;
  }

  eligibiliityCheck(amount){
    this.q_type   = "income";
    this.q_amount   = amount;
    this.q_l_type   = (this.type==emiGlobals.PersonalLoan_New?"New Loan" : "Balance Transfer");

    console.log("values",this.dataToApi);
    this.dataToApi.loanamount   = amount;
    this.dataToApi.loan_type    = this.type;
    this.dataToApi.purp         = this.getTypeSpecificValue('purp');
    this.dataToApi.pid          = this.getPid('eligibiliity');
    this.loanOfferService.generatePLCommonOffer(this.dataToApi);
  }

  getFielsDefaultValue(field,defaultvalue=null){
    var data = this.loanOfferService.getLocalCustomerInfoData(field);
    return (data?data:defaultvalue);
  }

  getTypeSpecificValue(field):number{
    switch(this.type){
      case emiGlobals.PersonalLoan_New:
        switch(field){
          case 'purp': {  return 1; }
          case 'pid' : {  return 1; }
        }
      break;
      case emiGlobals.PersonalLoan_Transfer:
        switch(field){
          case 'purp': {  return 6; }
          case 'pid' : {  return 5; }
        }
      break;
    }
  }

  getPid(tag):number{
    let purp  = this.dataToApi.purp;
    let emp_type   = this.dataToApi.emp_type; //
    let pid = 1;

    //Salaried New loan
         if(tag!="eligibiliity" && purp == 1 && (emp_type == 1 || emp_type == 5 || emp_type == 6 )){ pid = 1; }
    else if(tag=="eligibiliity" && purp == 1 && (emp_type == 1 || emp_type == 5 || emp_type == 6 )){ pid = 2; }
    // Self Employed New Loan
    else if(tag!="eligibiliity" && purp == 1 && (emp_type == 2 || emp_type == 3 || emp_type == 4 )){ pid = 3; }
    else if(tag=="eligibiliity" && purp == 1 && (emp_type == 2 || emp_type == 3 || emp_type == 4 )){ pid = 4; }

    //Salaried Balance Transfer
    else if(tag!="eligibiliity" && purp == 6 && (emp_type == 1 || emp_type == 5 || emp_type == 6 )){ pid = 7; }
    else if(tag=="eligibiliity" && purp == 6 && (emp_type == 1 || emp_type == 5 || emp_type == 6 )){ pid = 7; }
    // Balance Transfer
    else if(tag!="eligibiliity" && purp == 6 ){ pid = 3; }
    else if(tag=="eligibiliity" && purp == 6 ){ pid = 4; }
    
    return pid;
  }

  onEmploymentChange(emp_type) {
    console.log(emp_type);
    emp_type = this.option_emp_type[emp_type].value;
    if(emp_type==1 || emp_type==6 || emp_type==5 ){ // Salaried, Salaried Doctors, NRI Salaried
      this.showCompany = true;
      this.showDepreciation = false;
      this.showNatureOfProfession=false;
      this.PLForm.bank_title="Salary Account Bank";
      this.PLForm.income_title="Net Monthly Salary";
      this.PLForm.work_exp_title="Work Experience";
      //this.loanApplyForm.value['netsalary']=this.loanApplyForm.value['netsalary']/12;
    }else if(emp_type==2){ // Self Employed-Doctors
      this.showCompany = false;
      this.showDepreciation = true;
      this.showNatureOfProfession=false;
      this.PLForm.bank_title ="Current Account";
      this.PLForm.income_title ="Net Profit Per Annum";
      this.PLForm.work_exp_title="Professional Experience";
      //this.loanApplyForm.value['netsalary']=this.loanApplyForm.value['netsalary']*12;
    }else if(emp_type==3){ //  Self Employed-Professional
      this.showCompany = false;
      this.showDepreciation = true;
      this.showNatureOfProfession = true;
      this.PLForm.bank_title ="Current Account";
      this.PLForm.income_title ="Net Profit Per Annum";
      this.PLForm.work_exp_title="Professional Experience";
      //this.loanApplyForm.value['netsalary']=this.loanApplyForm.value['netsalary']*12;
    }else if(emp_type==4){ // Self Employed-Professional & Other
      this.showCompany = false;
      this.showDepreciation = true;
      this.showNatureOfProfession = true;
      this.PLForm.bank_title ="Current Account";
      this.PLForm.income_title ="Net Profit Per Annum";
      this.PLForm.work_exp_title="Business Experience";
      //this.loanApplyForm.value['netsalary']=this.loanApplyForm.value['netsalary']*12;
    }
  }

  onMobileFormName(dir):void{
    if(dir=="prev"){
      this.mobilecarouselform.prev()
    }else{
      this.mobilecarouselform.next()
    }
  }

  // Push a search company name  into the observable bank search stream.
  search($event): void {
    console.log("Option changed: ", $event);
    console.log("emp",this.loanApplyForm.value);
    //this.bankCompanySearchTerms.next(term);
  }

  loanAmountGenerated(){
    if(this.dataToApi&&this.dataToApi.loanamount){
      this.loan_amount_generated= true;
    }
      this.loan_amount_generated= false;
  }
 


  //this is the search function to get PL company names.
  fetchPLCompany(event){
    //this.mobileCarouselRowHeight=400;
    this.loanOfferService.searchBankComanyName(event.query)
      .subscribe(response => event.result(response));
  }

  searchCompanyName(query, callback) {
      this.loanOfferService.searchBankComanyName(query).subscribe((response)=> {
        if (response && response.length !== 0) {
          return callback(response);
        } else {
          return callback();
        }
      });
    };

  carouselSlideCallBack($event){
    console.log($event);
  }

  onPlMobileCarouselFormPrev(){
    this.mobilecarouselform.prev();
    console.log(this.mobilecarouselform);
  }
  onPlMobileCarouselFormNext(){
    this.mobilecarouselform.next();
    console.log(this.mobilecarouselform.activeId);
  }
  ngOnDestroy(): void {
    this.extra.unsubscribe();
}
showGif(value){
  this.gifActive=false;
  // this.gifDeactive=false;
}

// filterCompanyByBankId(items){
//   debugger
//   if(this.PlCompanyListFiltered){
//     this.PlCompanyListFiltered.length=0;
//  }
//   let filter_bank_id=JSON.parse(localStorage.getItem('PortalBank_Filter'));
// if(filter_bank_id.length==0){
//   this.PlCompanyListFiltered=items;
//   return this.PlCompanyListFiltered;
// }else{

//   if(items){
//     for(let j=0;j<items.length;j++){
//         for(let i=0;i<filter_bank_id.length;i++){
//            if(items[i]){
//              let bank=filter_bank_id[i];
//                if(bank){
//                  if(bank==items[j].bankid){
//                    this.ActualPlCompany=items[j];
//                    this.PlCompanyListFiltered.push(this.ActualPlCompany);
//                  }
//                }
//            }else{
//             console.log("no data");
//            }
//        }
//     }
//   console.log(this.PlCompanyListFiltered);
//   return this.PlCompanyListFiltered;

//   }

// }
// }


}



// WEBPACK FOOTER //
// ./src/app/loan/pl-form/pl-form.component.ts